/**
 * Sitedeki tek sosyal medya bağlantı kaynağı (navbar + footer + iletişim sayfası).
 *
 * Kural: **Instagram derneğin kendi hesabı**, diğer tüm hesaplar Fenerbahçe Spor
 * Kulübü'nün resmi hesaplarına gider.
 *
 * Neden ayarlardan değil de kodda: `server/data/` deploy edilmiyor
 * (bkz. scripts/deploy.sh --backend), bu yüzden ayarlar dosyasına yazılan
 * adresler canlıya taşınmıyordu ve footer eski/yanlış adresleri gösteriyordu.
 */
export const SOCIAL_LINKS = {
  /** Derneğin kendi Instagram hesabı — adres/künye olarak gösterilen yerlerde kullanılır. */
  instagram: 'https://www.instagram.com/fenerbahce_iskocya/',
  /** Fenerbahçe SK'nın resmi Instagram'ı — diğer kulüp ikonlarının yanındaki ikon için.
   *  (İletişim sayfasındaki düzenin aynısı: adres kartı derneğin, ikon ızgarası kulübün.) */
  instagramFb: 'https://www.instagram.com/fenerbahce',
  facebook: 'https://www.facebook.com/Fenerbahce',
  twitter: 'https://x.com/Fenerbahce',
  youtube: 'https://www.youtube.com/@fenerbahce',
  tiktok: 'https://www.tiktok.com/@fenerbahce',
  linkedin: 'https://www.linkedin.com/company/fenerbahce/',
  telegram: 'https://t.me/fenerbahce',
  website: 'https://www.fenerbahce.org',
};

/** Footer ve navbar'da gösterim sırası. */
export const SOCIAL_ORDER = [
  'instagram',
  'facebook',
  'twitter',
  'youtube',
  'tiktok',
  'linkedin',
  'telegram',
];

export const SOCIAL_LABELS = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  twitter: 'X (Twitter)',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  linkedin: 'LinkedIn',
  telegram: 'Telegram',
  website: 'fenerbahce.org',
};
